<template>
    <div>
        <div class="tree" >
            <el-tree
                    ref="tree"
                    :data="ceshiData"
                    node-key="i_id"
                    :props="defaultProps"
                    @node-click="handleNodeClick"
                    class="trees mrt10 video-tree"
                    accordion
                    default-expand-all
                    :highlight-current='highlighter'
                    :expand-on-click-node="false"
                    :current-node-key="currentNodekey">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span v-if="node.childNodes.length!=0">{{node.label+"("+node.childNodes.length+")"}}</span>
                    <span v-else>{{ node.label }}</span>
                    <span>
                      <el-button
                              v-if="data.vc_tcname=='考勤方案'"
                              type="text"
                              size="mini">
                        + 新增
                      </el-button>
                    </span>
              </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import {mapActions} from "vuex";
    export default {
        name: "TaskList",
        components: {},
        props:{
            tasklist:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                i_show:1,
                //nowTime:"",
                //startTime:"",
                //endTime:"",
                highlighter:true,
                currentNodekey:"",
                //openAll:true,
                defaultValue:"",
                checkTimevalue:'',
                addData:[],
                inDex:0,
                mid:0,
                treeExpandData:[],
                expanded:false,
                times:"",
                //highlightCurrentRow:false,
                tableData: [],
                ceshiData:[
                    {

                        vc_tcname:"考勤方案",
                        children:[

                        ],

                    }
                ],
                ID:"",
                iType:0,
                selfPro: [],
                replacePro: [],
                // begin_time: "",
                // end_time: "",
                defaultProps: {
                    children: 'children',
                    label: 'vc_tcname'
                },
                Node:{},
            }
        },
watch: {
    tasklist: {
        handler() {
            this.getKqList();
            if (this.tasklist) {
                // console.log(this.tasklist,"++++")
                let data = this.tasklist;
                let arr=[];
                arr=this.ceshiData[0].children.map(item => {
                    if (item.i_id == data.i_id) {
                        item = data;
                        // console.log(item,"88888",data)
                    }
                    return item;
                });
                this.ceshiData[0].children=arr;
                // console.log(this.ceshiData, "----------");
            }
        },
        immediate: true,
        deep: true
    },
},
        mounted() {
            // console.log("&&&&&&&")
            //this.getDateMonth();
            this.getKqList();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            append(data) {
                this.getKqList('click');
                // console.log(this.ceshiData);
                //     this.currentNodekey = this.ceshiData[0].children[0].i_id;
                //     this.$nextTick(() => {
                //         this.$refs.tree.setCurrentKey(this.currentNodekey);
                //     });
                //     this.handleNodeClick(data,this.Node)
            },



            handleNodeClick(data) {
                // console.log(data, "handleclick");
                if (data.vc_tcname=="考勤方案"){
                    let addData={
                        i_id:0,
                    };
                    this.$emit('getValue',addData)
                }else{
                    let addData={
                        i_id:data.i_id,
                        vc_tcname:data.vc_tcname,
                        vc_djmark:data.vc_djmark,
                        i_start:data.i_start,
                        i_end:data.i_end,
                        vc_createuser:data.vc_createuser,
                        dt_createtime:data.dt_createtime,
                        i_weektype:data.i_weektype,
                        f_ratio:data.f_ratio,
                    };
                    this.$emit('getValue',addData)
                }
               // console.log(data, node, "ataaaaaaa");
               //  this.Node=node;
               //  this.highlighter=true;
            },
            //考勤方案接口
            async getKqList(type='') {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,

                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    // console.log('zxc')
                    this.ceshiData[0].children=res.data;
                    if(type=='click'){
                        this.currentNodekey = this.ceshiData[0].children[this.ceshiData[0].children.length-1].i_id;
                        this.$nextTick(() => {
                            this.$refs.tree.setCurrentKey(this.currentNodekey);
                        });
                        this.handleNodeClick(this.ceshiData[0].children[this.ceshiData[0].children.length-1])
                    }
                    // console.log(res.data,'-00000');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },


        }
    }
</script>

<style lang="scss" scoped>
    .el-tree {

    }
   /* .tree {
        overflow: auto;
        height: calc(90vh - 80px)
    }*/

    .flex{
        justify-content: left;
    }

    .mrt10{
        margin-top: 3px;
    }
    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
       margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width:260px;
    }

    /deep/ {
        .el-tree-node__content{
            height: 100%;
        }
        .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
            background-color: var(--opacity);
        }
        .el-tree-node__content{
            width: 100%;
        }
        .el-tree-node{
            height: 40px;
            /*display: flex;*/
            /*align-items: center;*/
            /*justify-content: space-between;*/
        }

        .el-col-5{
            background-color:rgb(201,201,201) !important;
            border-right: 1px solid rgb(201,201,201) !important;
        }
        .el-tree-node__expand-icon{
            color: black;
        }

        .el-tree-node__expand-icon.is-leaf {
            color: transparent;
            cursor: default;
        }
        .el-tree-node__label {
            font-size: 17px;
        }

    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
/*
    @media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 530px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 685px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 610px;
        }
    }*/

    //实现滚动功能
    .video-tree {
        background-color: rgb(241,241,241);
        overflow-y: auto;
        max-height: calc(80vh);
        min-height: calc(40vh);
    }


</style>